import { api } from "~/utils/api";

export const usePersonTelecomPhoneNumber = (personId: string) => {
  return api.communication.getPersonTelecomPhoneNumber.useQuery(personId, {
    enabled: !!personId,
  });
};
